import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

function NaturalBirthdayCakesChennai() {
  const handleClickButton = (path) => {
    window.location.href = path;
  };

  return (
    <>
      <Helmet>
        <title>Natural Birthday Cakes in Chennai | Eggless & Preservative-Free</title>
        <link
          rel="canonical"
          href="https://wheatbakes.com/natural-birthday-cakes-chennai"
        />
      </Helmet>

      <Container className="my-5">
        {/* PAGE HEADER */}
        <Row className="mb-4">
            <p className="text-align-center brown-text-color text-bold-600">
              NO PRESERVATIVES NATURAL
            </p>
          <h1 className="text-bold-600 text-align-center">
            Natural Birthday Cakes
          </h1>
        </Row>

        {/* HERO SECTION */}
        <Row className="align-items-center mb-5">
          <Col lg={6}>
            <h2 className="fw-bold text-bold-600 mb-4">
            Natural Birthday Cakes in Chennai: What to Look For
            </h2>
            <p className="wheatbakes-para-justify">
              Birthday cakes are the heart of every celebration, especially when
              families and children are involved. But today, many people are
              rethinking traditional cakes loaded with refined flour, excess
              sugar, and artificial additives. If you’re searching for{" "}
              <span className="fw-semibold">natural birthday cakes in Chennai</span>, knowing what truly makes
              a cake “natural” can help you make a healthier and more meaningful
              choice.
            </p>

            <p className="wheatbakes-para-justify">
              At <span className="fw-semibold">WheatBakes</span>, we believe birthday cakes should celebrate
              both joy and well-being — without compromising on taste.
            </p>
          </Col>

          <Col lg={6}>
            <img
              src="images/product/cream_cakes.jpg"
              alt="Natural Birthday Cakes in Chennai"
              className="w-100 rounded"
            />
          </Col>
        </Row>

        {/* WHY NATURAL CAKES MATTER */}
        <section className="mb-5">
          <h2 className="fw-bold text-bold-600 mb-4">
            Why Natural Birthday Cakes Matter
          </h2>

          <p className="wheatbakes-para-justify">
            Conventional birthday cakes often rely on:
          </p>

          <Row className="g-4">
            {[
              "Refined flour (maida)",
              "Artificial colours and flavours",
              "High sugar content",
              "Preservatives for longer shelf life",
            ].map((item, idx) => (
              <Col md={6} key={idx}>
                <Card className="h-100 shadow-sm border-1">
                  <Card.Body>
                  <span style={{ color: "#dc3545", marginRight: "8px" }}>✘</span><span style={{color: "#dc3545"}} className="mb-0">{item}</span>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </section>

        {/* WHAT TO LOOK FOR */}
        <section className="mb-5">
          <p className="mt-4 wheatbakes-para-justify">
            Natural birthday cakes focus on clean ingredients and mindful baking,
            making them more suitable for children, elders, and health-conscious
            families.
          </p>
          <Row className="g-4">
            <Col md={6}>
              <Card className="h-100 shadow-sm border-0 p-3">
                <Card.Body>
                  <h5 className="fw-bold green-text">
                  <span style={{ color: "#0DAF50", marginRight: "8px" }}>✔</span> Choose Eggless Whole Wheat Cakes
                  </h5>
                  <p>One of the most important things to check is the base ingredient. <span className="fw-semibold">Eggless whole wheat cakes</span> are a healthier alternative because they:</p>
                  <ul>
                    <li>Retain natural fiber from whole wheat</li>
                    <li>Are easier to digest</li>
                    <li>Suit vegetarian families</li>
                    <li>Feel lighter compared to refined flour cakes</li>
                  </ul>
                  <p className="mb-0">
                    Eggless cakes also ensure that everyone at the celebration
                    can enjoy a slice without dietary concerns.
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="h-100 shadow-sm border-0 p-3">
                <Card.Body>
                  <h5 className="fw-bold green-text">
                  <span style={{ color: "#0DAF50", marginRight: "8px" }}>✔</span> Look for Low Sugar Natural Cakes
                  </h5>
                  <p>Birthday cakes don’t need to be overly sweet to taste good. <span className="fw-semibold">Low sugar natural cakes:</span></p>
                  <ul>
                    <li>Reduce sugar spikes, especially in children</li>
                    <li>Offer a balanced, pleasant sweetness</li>
                    <li>Allow guests to enjoy cake without feeling heavy</li>
                  </ul>
                  <p className="mb-0">
                    Lower sugar levels make cakes more suitable for family
                    celebrations where people of all ages are involved.
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="h-100 shadow-sm border-0 p-3">
                <Card.Body>
                  <h5 className="fw-bold green-text">
                  <span style={{ color: "#0DAF50", marginRight: "8px" }}>✔</span> Avoid Artificial Colours and Preservatives
                  </h5>
                  <ul>
                    <li>Artificial food colours</li>
                    <li>Synthetic flavours</li>
                    <li>Chemical preservatives</li>
                  </ul>
                  <p className="mb-0">
                    Freshly baked cakes made to order rely on quality ingredients
                    and proper baking — not additives — to deliver flavour and
                    softness.
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="h-100 shadow-sm border-0 p-3">
                <Card.Body>
                  <h5 className="fw-bold green-text">
                  <span style={{ color: "#0DAF50", marginRight: "8px" }}>✔</span>Fresh, Made-to-Order Baking Is Key
                  </h5>
                  <ul>
                    <li>Bake in small batches</li>
                    <li>Focus on local delivery</li>
                    <li>Avoid long storage</li>
                  </ul>
                  <p className="mb-0">
                    This ensures better taste, texture, and safety — especially
                    for children’s birthday celebrations.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="h-100 shadow-sm border-0 p-3">
                <Card.Body>
                  <h5 className="fw-bold green-text">
                  <span style={{ color: "#0DAF50", marginRight: "8px" }}>✔</span>Suitable for Kids, Elders & Families
                  </h5>
                  <ul>
                    <li>Safer for children</li>
                    <li>Easier for elders to digest</li>
                    <li>Ideal for family gatherings and home celebrations</li>
                  </ul>
                  <p className="mb-0">
                    This ensures better taste, texture, and safety — especially
                    for children’s birthday celebrations.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </section>

        {/* WHY WHEATBAKES */}
        <section className="mb-5">
          <h2 className="fw-bold text-bold-600">
            Why WheatBakes Is Trusted for Natural Birthday Cakes in Chennai
          </h2>
          <p className="wheatbakes-para-justify"><span className="fw-semibold">WheatBakes</span> is known for its clean and health-focused baking approach. We specialize in:</p>
          <ul>
            <li>Eggless whole wheat cakes</li>
            <li>Carefully balanced low sugar natural cakes</li>
            <li>No refined flour</li>
            <li>No artificial colours or preservatives</li>
            <li>Cakes made fresh for Chennai customers</li>
          </ul>

          <p className="wheatbakes-para-justify">
            Our cakes are designed to feel homemade, wholesome, and
            celebration-worthy.
          </p>

          <div className="my-4 d-flex">
            <button
              className="wheatbakes-btn m-auto"
              onClick={() => handleClickButton("https://wheatbakes.com/menu")}
            >
              Explore Natural Birthday Cakes
            </button>
          </div>
        </section>

        {/* FINAL SECTION */}
        <section className="py-5 bg-light rounded text-center">
          <h2 className="fw-bold text-bold-600 mb-3">
            Experience Natural, Preservative-Free Baking
          </h2>

          <p className="wheatbakes-para-justify">
            If you are looking for cakes made with care, honesty, and natural
            ingredients, WheatBakes is here for you. Enjoy the goodness of whole
            wheat and preservative-free baking — made fresh for Chennai
            customers.
          </p>

          <p className="wheatbakes-para-justify">
            Choosing the right birthday cake is about more than just design —
            it’s about ingredients, care, and the people you’re celebrating
            with. When looking for <span className="fw-semibold">natural birthday cakes in Chennai T Nagar,</span>
            focus on eggless whole wheat bases, low sugar content, and clean
            baking practices.
          </p>

          <p className="wheatbakes-para-justify">
            With <span className="fw-semibold">WheatBakes,</span> every birthday cake is crafted to bring happiness,
            health, and honest flavour to your celebration.
          </p>
          <div className="my-4 d-flex">
            <button
              className="wheatbakes-btn m-auto"
              onClick={() => handleClickButton("https://order.wheatbakes.com/onlineorder/")}
            >
              Order Now
            </button>
          </div>
        </section>
      </Container>
    </>
  );
}

export default NaturalBirthdayCakesChennai;
